import { createSlice } from '@reduxjs/toolkit';

/**
 * District scope of the *logged-in* user, derived from
 * `GET /api/auth/tenants/myProfile/get` (not from the auth token).
 * Consumed by useDistrictAccessHook to scope filters and address forms.
 */
interface UserLocationState {
  userId: number | null;
  locationIds: number[];
  loading: boolean;
  loaded: boolean;
}

const initialState: UserLocationState = {
  userId: null,
  locationIds: [],
  loading: false,
  loaded: false
};

const userLocationSlice = createSlice({
  name: 'userLocation',
  initialState,
  reducers: {
    setUserLocationsLoading(state, action) {
      state.userId = action.payload.userId ?? null;
      state.loading = true;
    },
    setUserLocations(state, action) {
      state.userId = action.payload.userId ?? null;
      state.locationIds = action.payload.locationIds || [];
      state.loading = false;
      state.loaded = true;
    },
    resetUserLocations() {
      return initialState;
    }
  }
});

export const { setUserLocationsLoading, setUserLocations, resetUserLocations } =
  userLocationSlice.actions;
export default userLocationSlice.reducer;
